import { createSpreadableBem } from "/Helpers/createBem";
import "./Tags.scss";
import { TagsProps } from "/App.GeneratedTypes";

const Tags = ({
  categoryTags,
  color,
  tagsLabel = "Emneknagger",
}: TagsProps) => {
  if (!categoryTags || categoryTags.length === 0) {
    return null;
  }

  const groupAriaLabel = `${tagsLabel}: ${categoryTags.join(", ")}`;
  const bem = createSpreadableBem("insight-tags-norad");

  const colorsMap = {
    "--standard": color === "Standard",
    "--insight": color === "Insight",
    "--inverted": color === "InsightInverted",
  };

  return (
    <fieldset {...bem("")}>
      <legend {...bem("__legend")}>{groupAriaLabel}</legend>
      {categoryTags.map((tag, index) => (
        <div {...bem("__tag-container", colorsMap)} key={index}>
          <div {...bem("__pipe", colorsMap)} />
          <span key={index} {...bem("__tag", colorsMap)}>
            {tag}
          </span>
          <div {...bem("__pipe", colorsMap)} />
        </div>
      ))}
    </fieldset>
  );
};

export default Tags;
